<template>
  <div class="mini-cart-empty">
    <div class="mini-cart-empty-body">
      <span class="mini-cart-empty-title">{{ $t('miniCart.emptyTitle') }}</span>
      <span class="mini-cart-empty-desc">{{ $t('miniCart.emptyDesc') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mini-cart-empty'
}
</script>

<style lang="scss" scoped>
.mini-cart-empty {
  height: calc(100vh - 5.9rem);
  text-align: center;
  overflow: auto;

  @media (map_get($breakpoints, sm)) {
    height: auto;
  }
}

.mini-cart-empty-body {
  padding: 6.5rem 2rem;
}

.mini-cart-empty-title {
  display: block;
  font-size: 2.4rem;
  font-weight: 500;
}

.mini-cart-empty-desc {
  color: $dark-grey;
  font-size: 1.4rem;
}
</style>
